export enum SupportedLocales {
  EN = 'en',
  ES = 'es',
}
